export default __webpack_public_path__ + "media/PACKAGESSTRUCTURE.209e13f8b4d7d0a0a2a7fddfa0858d34.mp4";